import ContactForm from './contact_form';
import CommentForm from './comment_form';
import SubsidyForm from './subsidy_form';
import PromotionForm from './promotion_form';
const Form = {
  init() {
    this._initValidations();
  },
  _initValidations() {
    ContactForm.init();
    CommentForm.init();
    SubsidyForm.init();
    PromotionForm.init();
  },
};
export default Form;



// WEBPACK FOOTER //
// ./scripts/modules/forms/form.js